import Tooltip from 'antd/lib/tooltip'
import { CopyIcon } from '../Icons/CopyIcon'
import styles from './CopyButton.module.less'
import Button from 'antd/lib/button'
import { useMessage } from 'shared/hooks/use-message'

export type CopyButtonProps = {
    contentToCopy: string
    showTooltip?: boolean
    copySuccessMessage?: string
    tooltipTitle?: string
    onClick?: (e: React.MouseEvent) => void
    className?: string
}

const CopyButton = (props: CopyButtonProps) => {
    const [messageApi] = useMessage()

    const onClickButton = (e: React.MouseEvent) => {
        if (props.copySuccessMessage) {
            messageApi.success(props.copySuccessMessage)
        }
        e.stopPropagation()
        navigator.clipboard.writeText(props.contentToCopy)
        props.onClick?.(e)
    }

    return props.showTooltip ? (
        <Tooltip
            title={props.tooltipTitle ?? `Copy ID: ${props.contentToCopy}`}
            data-testid="copy-button-wrapper"
        >
            <Button
                className={styles['copy-button-container']}
                onClick={onClickButton}
                data-testid="copy-button"
            >
                <CopyIcon />
            </Button>
        </Tooltip>
    ) : (
        <Button
            className={styles['copy-button-container']}
            onClick={onClickButton}
            data-testid="copy-button"
        >
            <CopyIcon />
        </Button>
    )
}

export default CopyButton
